<template>
  <nav class="coats-topnav navbar navbar-expand navbar-dark bg-primary">
    <a class="navbar-brand" href="#">
      <img :src="require('../assets/chain-white.svg')" height="32" />
    </a>

    <div class="row w-100 justify-content-center d-none d-md-inline-block offset-md-1">&nbsp;</div>
    <div class="d-md-inline-block ml-auto mr-0 mr-md-3 my-2 my-md-0">
      <ul class="navbar-nav ml-auto ml-md-0">
        <b-nav-item-dropdown menu-class="dropdown-menu-arrow" right no-caret>
          <template v-slot:button-content>
            <span class="avatar avatar-sm">
              <i class="fas fa-user"></i>
            </span>
          </template>
          <h6 class="dropdown-header">{{ currentUser && currentUser.email }}</h6>
          <b-dropdown-divider />
          <b-dropdown-item-button @click="logOut">
            <i class="las la-sign-out-alt nav-link-icon"></i> Sign out
          </b-dropdown-item-button>
        </b-nav-item-dropdown>
      </ul>
    </div>
  </nav>
</template>
<script>
import { mapState } from "vuex";
export default {
  methods: {
    async logOut() {
      this.$msal.signOut();
      window.location.href = "/";
    }
  },
  computed: {
    ...mapState(["currentUser"])
  }
};
</script>
